export function convertYoutubeUrl(url: string) {
  const regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/
  if (regExp.test(url)) {
    const match = url.match(regExp)
    const videoValue = match && match[2].length === 11 ? match[2] : null
    return 'https://www.youtube.com/embed/' + videoValue
  }
  return url
}
